<template>
  <product-upsell v-bind="forwarded" />
</template>

<script lang="ts" setup>
import type { Emits, Props } from '#commerce/components/product/upsell/Upsell.vue'
import ProductUpsell from '#commerce/components/product/upsell/Upsell.vue'

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
const forwarded = useForwardPropsEmits(props, emit)

const { $feature } = useNuxtApp()
const { brandClasses } = useAppConfig().components.product.upsell

if ($feature.tempShowATCAboveFold) {
  brandClasses.title = 'hidden'
  brandClasses.container = 'bg-brand-6 rounded-lg p-2 pl-4 dark:bg-grey-10'
  brandClasses.details.price = 'elevate-body-4 lg:text-sm'
  brandClasses.details.text = 'elevate-body-3 lg:text-sm'
  brandClasses.details.propsImg = 'w-20 grow-0 lg:w-16'
}
</script>
